import { createInstance, setLogger, enums } from '@optimizely/react-sdk';

const sdkKey = process.env.REACT_APP_OPTIMIZELY_SDK_KEY || 'default-sdk-key';

// Set up logging based on environment
const isDevelopment = process.env.NODE_ENV === 'development';
const logLevel = isDevelopment ? enums.LOG_LEVEL.INFO : enums.LOG_LEVEL.ERROR;

setLogger({
  log: (level, message) => {
    // Only log in development, or for errors in production
    if (isDevelopment || level === enums.LOG_LEVEL.ERROR) {
      console.log(`[Optimizely ${level}] ${message}`);
    }
  },
});

/**
 * Create and configure the Optimizely client instance
 * - Automatically updates the datafile at regular intervals
 * - Batches events for better performance
 * - Uses appropriate logging based on environment
 */
const optimizelyClient = createInstance({
  sdkKey,
  datafileOptions: {
    updateInterval: 300000, // Update datafile every 5 minutes
    autoUpdate: true, // Ensure automatic updates
    urlTemplate: 'https://cdn.optimizely.com/datafiles/%s.json' // Explicitly set the URL template
  },
  eventBatchSize: 10,
  eventFlushInterval: 3000, // Flush events every 3 seconds
  logLevel: logLevel
});

// Log client initialization status
let clientInitialized = false;

optimizelyClient.onReady({ timeout: 10000 })
  .then(() => {
    clientInitialized = true;
    console.log('Optimizely client is ready');
  })
  .catch((error) => {
    console.error('Optimizely client failed to initialize', error);
  });

/**
 * Check if the Optimizely client is ready
 * @returns {boolean} True if the client is initialized
 */
export const isOptimizelyReady = () => clientInitialized;

export default optimizelyClient;
